import { CYCLIC_SCHEDULE, DISCIPLINES, PROFESSORS, StudentServicePath } from "utils/constants";
import EditCyclicDisciplines from "./EditCyclicDisciplines";

export const resources = {
  isMenu: false,
  name: StudentServicePath + CYCLIC_SCHEDULE + "/" + DISCIPLINES + "/:id/" + PROFESSORS,
  title: "Редактиране на циклични дисциплини",
  custom: <EditCyclicDisciplines />,
};
